<template>
  <div class="transaction-item-info">
    <div
      class="transaction-item-info__item"
      v-for="(paymentInfo, index) in transaction.paymentInfo"
      :key="`payment-info-${index}`"
    >
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ paymentInfo.Caption }}
        </div>
        <div class="transaction-item-info__value">{{ paymentInfo.Value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Transaction } from '@js-app/entities/transaction/Transaction'

export default {
  name: 'TransactionItemPaymentInfo',
  props: {
    transaction: {
      type: Transaction,
    },
  },
}
</script>
